import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const CatalogLoadingPlaceholder = ({ label = "Caricamento...", className = "" }) => (
  <Box className={`cm-loading-placeholder${className ? ` ${className}` : ""}`}>
    <Typography className="cm-muted-text" align="center">
      {label}
    </Typography>
  </Box>
);

CatalogLoadingPlaceholder.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};

export default CatalogLoadingPlaceholder;
